import React from "react";
import { observer } from "mobx-react";
import { EsignatureRecipientViewStore } from "../../store";
import { EsignatureRecipientViewForm } from "./EsignatureRecipientViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type EsignatureRecipientViewProps = {
  esignatureRecipientViewStore: EsignatureRecipientViewStore;
};

export const EsignatureRecipientView: React.FC<EsignatureRecipientViewProps> =
  observer(({ esignatureRecipientViewStore }) => {
    return (
      <div>
        <EsignatureRecipientViewForm
          documentValue={esignatureRecipientViewStore.documentValue}
          email={esignatureRecipientViewStore.emailValue}
          name={esignatureRecipientViewStore.nameValue}
          role={esignatureRecipientViewStore.roleValue}
          order={esignatureRecipientViewStore.orderValue}
          statusOptions={esignatureRecipientViewStore.getStatusOptions()}
          status={esignatureRecipientViewStore.statusValue}
          signedAt={esignatureRecipientViewStore.signedAtValue}
          onPrint={(handlePrint: () => void) =>
            esignatureRecipientViewStore.printEsignatureRecipient(handlePrint)
          }
          onCancel={() =>
            esignatureRecipientViewStore.cancelEsignatureRecipient()
          }
          onEdit={
            esignatureRecipientViewStore.isEditEnabled
              ? () => esignatureRecipientViewStore.editEsignatureRecipient()
              : undefined
          }
        />
        <ErrorDialog
          open={esignatureRecipientViewStore.errorDialogOpened}
          title={esignatureRecipientViewStore.errorTitle}
          description={esignatureRecipientViewStore.errorDescription}
          onClose={() => esignatureRecipientViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
